import axios from "axios";
import React from "react";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;


async function getBroker(payload) {
    const result = await axios.post(apiUrl + "/admin/dropdown/getbrokers/jv",payload,{
         headers: jsonHeader}
    );
    return result.data || [];
}

async function getJvBrokerList(payload) {
    const result = await axios.post(apiUrl + "/jv/search/broker",payload,{
         headers: jsonHeader}
    );
    return result.data || [];
}

async function getUpdateJvBroker(payload) {
    const result = await axios.post(apiUrl + "/jv/update",payload,{
         headers: jsonHeader}
    );
    return result.data || [];
}

async function deleteJvBroker(payload) {
    const resultuser = await axios.post(apiUrl + "/jv/delete",payload,{
         headers: jsonHeader}
    );
    return resultuser.data || [];
}


export const JvBrokerListServices = {
    getBroker,
    getJvBrokerList,
    getUpdateJvBroker,
    deleteJvBroker
}